import { PositionProps } from '@chakra-ui/react'
import { HTMLAttributes } from 'react'
import { DisplayProps, MarginProps } from 'styled-system'

import { TestIdProps } from 'designSystem/types/propTypes'

import { SIZE } from 'designSystem/foundations/constants/size'

import PDSFlexBox from '../PDSFlexBox/PDSFlexBox'
import PDSIconButton from '../PDSIconButton/PDSIconButton'
import INTERNALxPaginationButton from '../internal/INTERNALxPaginationButton'
import { genPaginationRangeButtons } from './PDSPaginationUtils'

type BaseProps = HTMLAttributes<HTMLDivElement> &
  DisplayProps &
  PositionProps &
  MarginProps &
  TestIdProps

type Props = {
  currentPage: number
  neighborPageRange?: number
  onPageChange?: (page: number) => void
  pageSize: number
  totalCount: number
} & BaseProps

export default function PDSPagination({
  currentPage,
  neighborPageRange = 1,
  onPageChange,
  pageSize,
  testId,
  totalCount,
}: Props) {
  const pageCount = Math.max(Math.ceil(totalCount / pageSize), 1)

  const firstPage = 1
  const lastPage = pageCount

  const pages = genPaginationRangeButtons(
    pageCount,
    currentPage,
    neighborPageRange
  )

  return (
    <PDSFlexBox alignItems="center" gap={SIZE.s8} testId={testId}>
      <PDSIconButton
        disabled={currentPage === firstPage}
        name="chevronLeft"
        onClick={(e: React.SyntheticEvent) => {
          e.preventDefault()
          onPageChange?.(Math.max(currentPage - 1, firstPage))
        }}
        size="md"
        testId={testId && `${testId}-page-down`}
      />

      {pages.map((p, i) => {
        return (
          <INTERNALxPaginationButton
            key={`pagination-${i}`}
            text={p}
            isActive={p === currentPage}
            disabled={typeof p !== 'number'}
            onClick={(e: React.SyntheticEvent) => {
              e.preventDefault()
              if (typeof p === 'number') {
                onPageChange?.(p)
              }
            }}
            testId={testId && `${testId}-${p}`}
          />
        )
      })}

      <PDSIconButton
        disabled={currentPage === lastPage}
        onClick={(e: React.SyntheticEvent) => {
          e.preventDefault()
          onPageChange?.(Math.min(currentPage + 1, lastPage))
        }}
        name="chevronRight"
        size="md"
        testId={testId && `${testId}-page-up`}
      />
    </PDSFlexBox>
  )
}
